module.exports = __webpack_public_path__ + "81809adbc31421949742f75c8e3abf72.ttf";